module.exports = __webpack_public_path__ + "uc/img/no-data.08b29ef4.png";